/**
 * JIM-0922-01: the client signature request rides along with Send to Client.
 *
 * Jim 2026-09-22: "build out the ability for client to sign it when they are
 * emailed it and some sort of indication it has been completed." The send
 * response says who was asked to sign (or that the on-file signature was
 * applied automatically); the Sent screen and the Unsent list show it.
 */
export type ClientSignatureSummary = {
  status: 'pending' | 'signed' | 'declined' | string;
  signer_name: string;
  signer_email: string;
  auto_applied?: boolean;
};

/** One plain line for the inspector, or null when the site takes no client signature. */
export function clientSignatureLine(
  sig: ClientSignatureSummary | null | undefined
): string | null {
  if (!sig) return null;
  if (sig.auto_applied)
    return `Client signature applied automatically for ${sig.signer_name}.`;
  if (sig.status === 'signed') return `Client signed — ${sig.signer_name}.`;
  if (sig.status === 'pending') {
    // JIM-1003-02: several contacts may be asked; the server lists them
    // comma-separated and the first to act signs.
    if (sig.signer_email.includes(','))
      return `Awaiting client signature — ${sig.signer_name} each have the signing links in their copy of the report. The first to sign signs it.`;
    return `Awaiting client signature — ${sig.signer_name} (${sig.signer_email}) has the sign button in their copy of the report.`;
  }
  return null;
}
